import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'components/ui/accordion/Accordion';
import Actions from 'components/ui/general/Actions';
import BookingReservationHeader from './BookingReservationHeader';
import Button from 'components/button/ActionButton';
import Column from 'components/ui/show/Column';
import DateTimeTextField from 'components/show/DateFields/DateTimeTextField';
import InnerColumn from 'components/ui/show/InnerColumn';
import ProductShowField from 'components/show/ProductShowField';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import authHelper from 'helpers/auth';
import categoryHelper from 'helpers/category';
import compose from 'recompose/compose';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ImageEyeIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { fetchBookingReservations } from 'store/actions/bookingReservations/fetchBookingReservations';
import { push } from 'react-router-redux';
import { updateReservationFilter } from 'store/actions/reservations/updateReservations';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';

const StyledWrapper = styled.div`
    margin: 0 0 20px 0;
`;

class BookingReservations extends React.Component {
    componentDidMount() {
        const {
            fetch,
            id,
            reservations,
        } = this.props;

        if (utils.isEmpty(reservations)) {
            fetch(id);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            fetch,
            id,
        } = this.props;

        if (prevProps.id !== id) {
            fetch(id);
        }
    }

    render() {
        const {
            dispatchReservationAction,
            loading,
            reservations,
            translate,
        } = this.props;

        if (loading || utils.isEmpty(reservations)) {
            return null;
        }

        return (
            <StyledWrapper>
                { reservations.map((reservation, index) => {
                    const {
                        booking_data: bookingData,
                        product,
                    } = reservation;

                    const categoryId = product.category_id;

                    const isBikeProduct = categoryHelper.isBike(categoryId);
                    const isHubProduct = categoryHelper.isHub(categoryId);
                    const isParkingProduct = categoryHelper.isParking(categoryId);
                    const isTaxiProduct = categoryHelper.isTaxi(categoryId);
                    const isTransferProduct = categoryHelper.isTransfer(categoryId);

                    return (
                        <Accordion
                            key={ `reservation__${ reservation.id }` }
                            open={ index === 0 ? true : false }
                            label={ <BookingReservationHeader product={ product } booking={ bookingData } /> }
                        >
                            <Section>
                                <Column
                                    actions={
                                        <Actions>
                                            { authHelper.isAdmin() &&
                                                <Button
                                                    icon={ <ImageEyeIcon /> }
                                                    onClick={ () => {
                                                        dispatchReservationAction(reservation.order_id);
                                                    } }
                                                    title={ translate('actions.show') }
                                                />
                                            }
                                        </Actions>
                                    }
                                    size={ 8 }
                                    title={ translate('resources.orders.show.travel_details') }
                                >
                                    <InnerColumn>
                                        <DateTimeTextField
                                            label={ (isTaxiProduct || isTransferProduct) ? 'resources.orders.fields.pick_up_date' : 'resources.orders.fields.starting_at' }
                                            value={ bookingData.destination_arrival_date }
                                        />

                                        { (isTaxiProduct || isTransferProduct) &&
                                            <div>
                                                <TextField
                                                    label='resources.orders.fields.origin_address'
                                                    value={ bookingData.origin_address }
                                                />

                                                <TextField
                                                    label='resources.orders.fields.destination_address'
                                                    value={ bookingData.destination_address }
                                                />
                                            </div>
                                        }
                                    </InnerColumn>

                                    { (isBikeProduct || isHubProduct || isParkingProduct) &&
                                        <InnerColumn>
                                            <DateTimeTextField
                                                label='resources.orders.fields.ending_at'
                                                value={ bookingData.destination_departure_date }
                                            />
                                        </InnerColumn>
                                    }

                                    { (!isBikeProduct && bookingData.number_of_persons) &&
                                        <InnerColumn>
                                            <TextField
                                                label='resources.orders.fields.number_of_persons'
                                                value={ bookingData.number_of_persons }
                                            />
                                        </InnerColumn>
                                    }
                                </Column>

                                <Column
                                    size={ 4 }
                                    title={ translate('resources.orders.show.product') }
                                >
                                    <InnerColumn>
                                        <ProductShowField
                                            hideLabel
                                            product={ product }
                                        />
                                    </InnerColumn>
                                </Column>
                            </Section>
                        </Accordion>
                    );
                }) }
            </StyledWrapper>
        );
    }
}

BookingReservations.propTypes = {
    dispatchReservationAction: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    id: PropTypes.number,
    loading: PropTypes.bool.isRequired,
    reservations: PropTypes.array,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        id,
    } = props;

    return {
        loading: state.bookingReservations.loading,
        reservations: state.bookingReservations.data[id],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (id) => {
            dispatch(fetchBookingReservations({
                id: id,
            }));
        },
        dispatchReservationAction: (orderId) => {
            dispatch(updateReservationFilter({
                filter: {
                    internal_order_id: {
                        matchType: filterMatchTypes.matchOneOf,
                        value: [
                            orderId,
                        ],
                    },
                },
            }));

            dispatch(push('/reservations'));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(BookingReservations);



// WEBPACK FOOTER //
// ./src/pages/bookings/bookingReservations/BookingReservations.js